export default "__VITE_ASSET__BITLhiOT__"